import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Search, ArrowLeft, Clock, GraduationCap } from "lucide-react";

export default function LearningCenter() {
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");
  const [selected, setSelected] = useState(null);

  const load = async () => {
    const { data } = await api.get("/success/learning", { params: { q: q || undefined, category: cat || undefined } });
    setItems(data.items || []);
    setCategories(data.categories || []);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [cat]);

  if (selected) {
    return (
      <div className="max-w-3xl">
        <button onClick={() => setSelected(null)} className="text-sm text-slate-500 hover:text-navy inline-flex items-center gap-1 mb-4">
          <ArrowLeft className="w-4 h-4" /> All articles
        </button>
        <div className="eyebrow mb-2">{selected.category}</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-navy">{selected.title}</h1>
        <div className="text-sm text-slate-500 mt-2 inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {selected.read_minutes} min read</div>
        <article className="mt-8 prose prose-slate max-w-none">
          {selected.content.split("\n").map((line, i) => {
            if (line.startsWith("# ")) return <h1 key={i} className="font-display text-3xl text-navy mt-6">{line.slice(2)}</h1>;
            if (line.startsWith("## ")) return <h2 key={i} className="font-display text-2xl text-navy mt-6">{line.slice(3)}</h2>;
            if (line.startsWith("**") && line.endsWith("**")) return <p key={i} className="font-semibold text-navy mt-4">{line.replace(/\*\*/g, "")}</p>;
            if (line.startsWith("- ")) return <li key={i} className="ml-6 text-slate-700">{line.slice(2)}</li>;
            if (!line.trim()) return <div key={i} className="h-2" />;
            return <p key={i} className="text-slate-700 leading-relaxed">{line.replace(/\*\*(.*?)\*\*/g, "$1")}</p>;
          })}
        </article>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6">
        <div className="eyebrow mb-2">Success Center</div>
        <h1 className="font-display text-3xl font-bold text-navy">Learning Center</h1>
        <p className="text-sm text-slate-500 mt-1">Best-practice articles, playbooks, and checklists to sharpen your craft.</p>
      </div>

      <div className="flex gap-3 mb-6 flex-wrap">
        <form onSubmit={e => { e.preventDefault(); load(); }} className="flex-1 relative min-w-[240px]">
          <Search className="absolute left-3 top-3 w-4 h-4 text-slate-400" />
          <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search articles…" className="pl-9 w-full border border-slate-200 rounded-md px-3 py-2.5 text-sm" />
        </form>
        <select value={cat} onChange={e => setCat(e.target.value)} className="border border-slate-200 rounded-md px-3 py-2.5 text-sm">
          <option value="">All categories</option>
          {categories.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(a => (
          <button key={a.slug} onClick={() => setSelected(a)}
            className="card-lift text-left border border-slate-200 rounded-xl bg-white p-5">
            <div className="h-10 w-10 rounded-lg bg-gold/10 text-gold grid place-items-center mb-3"><GraduationCap className="w-5 h-5" /></div>
            <div className="text-xs uppercase tracking-widest text-slate-500">{a.category}</div>
            <div className="font-display text-lg font-semibold text-navy mt-1">{a.title}</div>
            <div className="text-sm text-slate-500 mt-2 inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {a.read_minutes} min read</div>
          </button>
        ))}
        {items.length === 0 && <div className="text-slate-500 col-span-full">No articles match your search.</div>}
      </div>
    </div>
  );
}
